import React, { useEffect } from 'react';

export default function Modal({ title, onClose, children, wide }) {
  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className="pred-modal-backdrop" onMouseDown={event => event.target === event.currentTarget && onClose()}>
      <div className={`pred-modal ${wide ? 'is-wide' : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className="pred-modal-head">
          <h2>{title}</h2>
          <button className="pred-icon-btn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="pred-modal-body">{children}</div>
      </div>
    </div>
  );
}
